import { Truss } from '@paragon/contract-library';
import { SimpleCache } from '@paragon/utilities';

export class WidthCacheClass extends SimpleCache<number> {
  get(analysisSetGuid: string, truss: Truss) {
    return this.getOrCreate(analysisSetGuid, () => {
      const memberXs = truss.members.flatMap((member) => member.geometry).map((point) => point.x);
      const leftmostX = Math.min(...memberXs);
      const rightmostX = Math.max(...memberXs);
      const width = Math.abs(rightmostX - leftmostX);
      return width;
    });
  }
}
